import { Experiments } from 'constants/experiments'
import config from 'constants/config'
import useExperiment from 'hooks/Experiments/useExperiment'
import { resolveRebrandVersion, type RebrandVersion } from 'lib/theme/paletteVersion'

/** Resolves the active rebrand palette version from the canonical experiment hook. */
function useRebrandVersion(): RebrandVersion {
  const { variation } = useExperiment(Experiments.croRebrand, {
    canActivate: false,
    overrideTrigger: true,
  })

  return config.BRAND === 'leagenthub' ? 'rebrand' : resolveRebrandVersion(variation)
}

export default useRebrandVersion
